import { apiClient } from './client';
import type { PanelUser, CreateUserRequest, UpdateUserRequest } from '../types';

export const usersApi = {
  getAll: async (firmId?: number): Promise<PanelUser[]> => {
    const params = firmId ? { firmId } : {};
    const response = await apiClient.get<PanelUser[]>('/api/users', { params });
    return response.data;
  },

  getById: async (id: number): Promise<PanelUser> => {
    const response = await apiClient.get<PanelUser>(`/api/users/${id}`);
    return response.data;
  },

  create: async (data: CreateUserRequest): Promise<PanelUser> => {
    const response = await apiClient.post<PanelUser>('/api/users', data);
    return response.data;
  },

  update: async (id: number, data: UpdateUserRequest): Promise<PanelUser> => {
    const response = await apiClient.put<PanelUser>(`/api/users/${id}`, data);
    return response.data;
  },

  resetPassword: async (id: number, newPassword: string): Promise<void> => {
    await apiClient.post(`/api/users/${id}/reset-password`, { newPassword });
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/users/${id}`);
  },
};
